module.exports = __webpack_public_path__ + "img/1_012.a9d418bf.jpg";